<template>
  <div id="app">
    <router-view/>
    
    <!-- 资源更新检测组件 -->
    <CheckUpdates />
  </div>
</template>

<script>
import CheckUpdates from '@/components/check-updates'

export default {
  name: 'App',
  components: {
    CheckUpdates
  }
}
</script>

<style>
/* App组件样式 */
#app {
  min-height: 100%;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
